import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getDate } from '@src/utils/index';

const Banner = ({ content }) => {
    const date = getDate(content.timestamp);

    return (
        <div className={styles.banner} style={{ backgroundImage: `url("${content.backgroundImg}")` }}>
            <div className={styles.bannerLeft} style={{ backgroundImage: `url("${content.logo}")` }}>
                <div className={styles.bannerSlogan}>{ content.intro }</div>
            </div>
            <div className={styles.bannerRight}>
                <div className={styles.bannerDate}>
                    <div className={styles.bannerYear}>{ date.year }</div>
                    <div className={styles.bannerMonth}>{ date.month }月{ date.day }日</div>
                </div>
                <div className={styles.bannerWeek}>{ date.week }</div>
            </div>
        </div>
    );
};

Banner.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Banner);
